import sift from "sift";
export var initBuildings = function initBuildings(a, b) {
  var c = b.parseUrl,
      d = a.packages.list({
    propertyType: "apartment"
  }); // buildings.map(building => {
  //   building.levels.map(level => {
  //     apartments = [...apartments, ...level.apartments];
  //     return level;
  //   });
  //   return building;
  // });

  return {
    list: function list() {
      var b = a.current || {},
          c = b.apartments || []; // if (apartments) {
      //   apartments.map(release => (apartments = [...apartments, ...release.apartments]));
      //
      //   const siftQuery = { $and: [], $or: [] };
      //   if (!siftQuery.$and.length) delete siftQuery.$and;
      //   if (!siftQuery.$or.length) delete siftQuery.$or;
      //
      //   apartments = apartments.filter(sift(siftQuery));
      // }

      return {
        data: c
      };
    },
    retrieve: function retrieve(b) {
      var d = a.current || {},
          e = d.packages || [],
          f = d.apartments || [],
          g = f.find(function (a) {
        return a.slug === b;
      });
      return g && (g.levels = g.levels.map(function (a) {
        return a.apartments = a.apartments.map(function (a) {
          if (a && a.package_id) {
            var b = e.find(function (b) {
              var c = b.id;
              return c === a.package_id;
            });
            if (b) return b;
          }

          return a;
        }), a.apartments = a.apartments.filter(function (a) {
          return a;
        }), a.image && a.image.url && (a.image.url = c(a.image.url)), a;
      })), g;
    },
    filters: function filters() {
      var b = a.data || {},
          e = b.apartmentSearch,
          f = e.layout_type.options.map(function (a) {
        var b = a.name;
        return b;
      }),
          g = e.apartment_type.options,
          h = d.filter(sift({
        $and: [{
          $or: [{
            layout_type: {
              $in: f
            }
          }, {
            apartment_type: {
              $in: g
            }
          }]
        }, {
          $or: [{
            status_id: 1
          }, {
            status: 1
          }]
        }]
      })),
          i = [],
          j = [];
      return h.map(function (a) {
        a.apartment_type.map(function (a) {
          return i.includes(a) || i.push(a), a;
        });
        var b = a.layout_type;
        return j.includes(b) || j.push(b), a;
      }), e.apartment_type.options = i, e.layout_type.options = e.layout_type.options.filter(function (a) {
        var b = a.name;
        return j.includes(b);
      }), e.layout_type.options = e.layout_type.options.map(function (a) {
        var b = h.find(function (b) {
          var c = b.layout_type;
          return c === a.name;
        }),
            d = b.bedrooms,
            e = b.bathrooms;
        return a.image && (a.image.url = c(a.image.url)), a.label = "".concat(d, " BEDROOM - TYPE ").concat(a.name), a.bathrooms = e, a.bedrooms = d, a;
      }), e;
    }
  };
};
export default initBuildings;